import { defineMessages } from 'react-intl';

/** The copy of the proof choice of the Message step (pitch email v3, owner decision 2026-10-27). */
export const proofMessages = defineMessages({
  title: { id: 'app.outreach.builder.proof.title', defaultMessage: 'What can Plug show as proof?' },
  hint: {
    id: 'app.outreach.builder.proof.hint',
    defaultMessage:
      'Pick up to {max}. Plug uses only these in the pitch and in the song card. It never invents a number.',
  },
  streams28d: { id: 'app.outreach.builder.proof.streams28d', defaultMessage: '{value} streams in the last 28 days' },
  monthlyListeners: {
    id: 'app.outreach.builder.proof.monthlyListeners',
    defaultMessage: '{value} monthly listeners on Spotify',
  },
  followers: { id: 'app.outreach.builder.proof.followers', defaultMessage: '{value} followers on Spotify' },
  playlistAdds: { id: 'app.outreach.builder.proof.playlistAdds', defaultMessage: '{value} playlist adds so far' },
  fromData: { id: 'app.outreach.builder.proof.fromData', defaultMessage: 'From your data' },
  notInData: {
    id: 'app.outreach.builder.proof.notInData',
    defaultMessage: 'Saved before. This number is not in your data now. Uncheck it to remove it.',
  },
  none: {
    id: 'app.outreach.builder.proof.none',
    defaultMessage: 'No numbers yet. Connect Spotify for Artists or your distributor in the Catalog.',
  },
  freeLabel: { id: 'app.outreach.builder.proof.freeLabel', defaultMessage: 'Your own line' },
  freeLimit: {
    id: 'app.outreach.builder.proof.freeLimit',
    defaultMessage: 'Up to {max} characters, only true facts. For example: BBC Introducing played my last single.',
  },
  full: { id: 'app.outreach.builder.proof.full', defaultMessage: 'You picked {max}. Clear one to pick another.' },
  failed: { id: 'app.outreach.builder.proof.failed', defaultMessage: 'Your choice was not saved. Try again.' },
});
